export const handleScroll = (id: string, scroll: number) => {
    const section = document.getElementById(id);
    if (section) {
        const offset = scroll;
        const top = section.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });
    }
};
